import { render } from "react-dom";
import { createElement } from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { Root } from "./Root.fs.js";
import "./styles/global.scss";


render(createElement(Auth0Provider, {
    domain: "dev-wecheck-partner-portal.eu.auth0.com",
    clientId: "6QA9Tdya33OL4flF3Va9Vo7yKBQo4faw",
    redirectUri: window.location.origin,
    children: createElement(Root, null),
}), document.getElementById("feliz-app"));

